module.exports = __webpack_public_path__ + "static/media/02ahorro.12a9709.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/02ahorro.mp4
// module id = 717
// module chunks = 1